<div class="row" style="background-color:white" >
    <div class="col-2">
        <!-- profile -->
            <div id="mySidenav" class="sidenav">
                <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a>
                            <div style="background-color:rgb(160, 9, 9)" class="pt-5">
                                <h1 id="Sign" class="text-center">
                                    <strong style="color:white;"> Profile</strong>
                                    <!-- <hr class="show"> -->
                                </h1>
                            </div>
                                <div style="background-color:#EDEDED" class="p-3">
                                    <img [src]="online.img" id="image">
                                </div>
                                <div class="form-group bg-light p-4">
                                    <p>{{online.userName}}</p>
                                    <!-- <p>{{myProfile.mobile}}</p> -->
                                </div>
                                <div class="jumbotron">
                                    <p class="text-danger h4">Bio</p>
                                    <p>I am a Developer</p>
                                </div>
                    
                </div>    
           <!-- profile ending -->
        <div (click)="openNav()" class="offset-2 p-2" >
            <img [src]="online.img"  style="height: 50px; width: 50px; border-radius: 100%;;"/>
            <!-- IMAGE -->  
        </div>
    </div>
    <div class="col-4 mt-2" >
         <!-- <h4>{{online.userName | userName}}</h4> -->
         <h4>{{online.userName }}</h4>
        <!-- <h5 class="text-muted" style="margin-top: -18px !important;"></h5> -->
    </div>

    <div class="col-md-4">
        <div class="row">
            <div class="col -4 p-2" >
            <div>
                <img *ngIf="showpro" [src]="msgReceiver.picture"  style="height: 50px; background-color:#E7E7E7;  width: 50px; margin-top: 5px; border-radius: 100%;">
            </div>
            </div>

            <!-- <button type="button"  class="btn btn-primary btn-lg" data-toggle="modal" data-target="#modelId" ></button>
            <div class="modal fade" id="modelId" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true"></div>
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Modal Title</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            Body
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">close</button>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="col-8" style="margin-left: -70px !important;">
                <h4 class="mt-3 text-uppercase">{{msgReceiver.userName}}</h4>
                
            </div>
        </div>  


   
    <div class="col-md-2">
        <!-- <img src="/assets/logo.png" alt=""  style="height: 25px; float: right; margin-top: 15px; margin-right: -100px"> -->
    </div>
</div>